import { useEffect, useState } from "react";
import TextArea from "@ingka/text-area";
import FormField from "@ingka/form-field";
import LabelWithToolTip from "../LabelWithTooltip/LabelWithToolTip";

type TextAreaFieldProps = {
  id: string;
  type: "text" | "textarea";
  labelText: string;
  toolTipText?: string;
  initialValue?: string;
  helperMsg?: string | boolean;
  disabled?: boolean;
  shoudlValidate?: boolean;
  errorMessage?: string;
  onBlur?: (value: string) => void;
  onChange?: (value: string) => void;
};

export const TextAreaField = ({
  id,
  labelText,
  toolTipText,
  initialValue,
  helperMsg,
  disabled,
  shoudlValidate,
  errorMessage,
  onBlur,
  onChange,
}: TextAreaFieldProps) => {
  const [value, setValue] = useState(initialValue);

  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  return (
    <FormField
      valid="error"
      validation={{
        msg: errorMessage,
        type: "error",
      }}
      shouldValidate={shoudlValidate}
      fieldHelper={{
        id: `field-helper-${id}`,
        msg: helperMsg ? `User input: ${helperMsg}` : "",
      }}
    >
      <TextArea
        id={id}
        label={
          <LabelWithToolTip labelText={labelText} toolTipText={toolTipText} />
        }
        rows={5}
        value={value}
        disabled={disabled}
        onChange={(e) => {
          const { value } = e.target;
          setValue(value);
          onChange && onChange(value);
        }}
        onBlur={() => onBlur && onBlur(value!)}
      />
    </FormField>
  );
};
